export enum TaskFilterType {
  Acquisition = 'acquisition',
  File = 'file',
  Session = 'session',
}

export enum TaskParentContainerType {
  Acquisition = 'acquisition',
  File = 'file',
  Group = 'group',
  Project = 'project',
  Session = 'session',
  Subject = 'subject',
}

export enum TaskStatus {
  Complete = 'Complete',
  InProgress = 'In_progress',
  Todo = 'Todo',
}

export enum TaskType {
  Form = 'F',
  Query = 'Q',
  Read = 'R',
  Custom = 'C',
}

export enum TaskViewer {
  Form = 'Form',
  OHIF = 'OHIF',
  OHIFV3 = 'OHIF_V3',
}
